/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { BonificaDto, GetBonificheParams } from ".././models";

export const getBonifiche = (
  portale: 1 | 2 | 3,
  params?: GetBonificheParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<BonificaDto[]>> => {
  return axios.get(`/api/portali/${portale}/bonifiche`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetBonificheQueryKey = (
  portale: 1 | 2 | 3,
  params?: GetBonificheParams
) =>
  [`/api/portali/${portale}/bonifiche`, ...(params ? [params] : [])] as const;

export const getGetBonificheQueryOptions = <
  TData = Awaited<ReturnType<typeof getBonifiche>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetBonificheParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBonifiche>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<Awaited<ReturnType<typeof getBonifiche>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBonificheQueryKey(portale, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBonifiche>>> = ({
    signal,
  }) => getBonifiche(portale, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!portale, ...queryOptions };
};

export type GetBonificheQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBonifiche>>
>;
export type GetBonificheQueryError = AxiosError<unknown>;

export const useGetBonifiche = <
  TData = Awaited<ReturnType<typeof getBonifiche>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetBonificheParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBonifiche>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBonificheQueryOptions(portale, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetBonifiche = () =>
  //@ts-ignore
  useGetBonifiche(...([] as any[]));
